import {NgModule} from '@angular/core';
import {CoreModule} from '../core';
import {SubjectsStorage} from './subjects-storage';
import {SharedModule} from '../shared';
import {LabTestsGridComponent} from './lab-tests-grid.component';
import {LabTestResultModule} from '../lab-test-results/lab-test-results.module';
import {LabTestsChartComponent} from './lab-tests-chart.component';
import {CovanceAgGridModule} from '../covance-ag-grid/covance-ag-grid.module';
import {StandardTestResultsMainModule} from '../on-screen-results/standard-test-results/standard-test-results-main.module';
import {LabTestsChartDataGenerator} from './lab-tests-chart-data-generator';
import {LabTestGridVisitHeaderComponent} from './lab-tests-grid-visit-header.component';
import {LabTestGridVisitComponent} from './lab-tests-grid-visit.component';
import { CovanceFilterModule } from '../covance-filter';
import { ReactiveFormsModule } from '@angular/forms';
import { LegendModule } from '../legend/legend.module';
import { CorporateModule } from '../corporate/corporate.module';
import { StandardTestResultHelpers } from '../on-screen-results/standard-test-results/standard-test-result-helpers';

@NgModule({
    imports: [
        SharedModule,
        CoreModule,
        LabTestResultModule,
        StandardTestResultsMainModule,
        CovanceAgGridModule,
        CovanceFilterModule,
        ReactiveFormsModule,
        LegendModule,
        CorporateModule,
    ],
    declarations: [
        LabTestGridVisitHeaderComponent,
        LabTestGridVisitComponent,
        LabTestsGridComponent,
        LabTestsChartComponent
    ],
    entryComponents: [
        LabTestGridVisitHeaderComponent,
        LabTestGridVisitComponent,
    ],
    providers: [
        SubjectsStorage,
        LabTestsChartDataGenerator,
        StandardTestResultHelpers
    ]
})
export class SubjectsModule { }